import { createAsyncThunk } from "@reduxjs/toolkit";
import { getV1Languages } from "../../../api-client/api.system-feature/api";
import { getToken } from '../../../utils/common';

export const fetchLanguages = createAsyncThunk(
  "header/language/get",
  async () => {
    const response = await getV1Languages({
      order: `id:1`,
      ...getToken(),
    });
    const data = response?.data?.languages || [];
    const languages = data?.filter(d => d?.is_active)?.map(d => {
      return {
        label: d?.name,
        code: d?.code,
        direction: d?.direction
      }
    },
    );
    return { languages }
  });
